import { render, staticRenderFns } from "./SithMesTpmAxisDataTadEdit.vue?vue&type=template&id=aa397870&"
import script from "./SithMesTpmAxisDataTadEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesTpmAxisDataTadEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports